var portfolioPositionsPerformance = {
	caption: "Portfolio positions performance",
	label: {
		name: "Libellé",
		isin: "ISIN",
		performance: "Perf.",
		performanceRelative: "Perf. %",
		performanceBar: "Perf. % of max"
	},
	noPositions: "Aucun résultat trouvé"
};
var fr = {
	portfolioPositionsPerformance: portfolioPositionsPerformance
};

export { fr as default, portfolioPositionsPerformance };
